import { useEffect, useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { stuckRows, type StuckRow } from '../services/sync/outbox'
import { syncBus } from '../services/sync/bus'

/** Bu cihazda takılı kalmış (gönderilemeyen) kayıtlar, canlı. */
export function useStuckRows(): StuckRow[] {
  const { tenantId, isAuthenticated } = useAuth()
  const [rows, setRows] = useState<StuckRow[]>([])

  useEffect(() => {
    if (!tenantId || !isAuthenticated) {
      setRows([])
      return
    }
    let alive = true
    const read = () =>
      void stuckRows(tenantId)
        .then((r) => alive && setRows(r))
        .catch(() => {})
    read()
    const off = syncBus.on('outbox-changed', read)
    const t = window.setInterval(read, 20_000)
    return () => {
      alive = false
      off()
      window.clearInterval(t)
    }
  }, [tenantId, isAuthenticated])

  return rows
}
